import React from "react";
import "./WebSolutions.scss"; 
import PageBanner from "../layouts/PageBanner";
import bannerWeb from "../../assets/about-hero.jpg";
import WebSolutionsShowcase from "./WebSolutionsShowcase";

const WebSolutionspage = () => {
  return (
    <div className="avena-services-page">
      <PageBanner
        title="Web Solutions"
        bg={bannerWeb}
        crumbs={[
          { label: "Avena", href: "/" },
          { label: "Web Solutions" },
        ]}
      />
      <WebSolutionsShowcase />
    </div>
  );
};

export default WebSolutionspage;
